import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Violation.css";

const HandleDfmsTruckDefect = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    resolution_remarks: "",
    date_resolved: "",
    resolved: true,
  });
  const [recordInfo, setRecordInfo] = useState(null);
  const [message, setMessage] = useState("");

  const getCurrentLocalDateTime = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}T${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
  };

  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/dfms-truck-defects/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const raw = response.data?.data || response.data || {};
        const normalized = {};
        Object.keys(raw || {}).forEach((key) => {
          normalized[key.toLowerCase()] = raw[key];
        });
        setRecordInfo({
          truck: normalized.scheduled_vehicle,
          journey: normalized.journey_plane_no,
          driver: normalized.driver_name,
        });
        setForm({
          resolution_remarks: normalized.resolution_remarks || "",
          date_resolved: getCurrentLocalDateTime(),
          resolved: true,
        });
      } catch (error) {
        console.error("Error fetching DFMS defect:", error);
        setMessage("Failed to load DFMS defect.");
      }
    };
    load();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const convertToUTC = (localDateTime) => {
    const date = new Date(localDateTime);
    return Number.isNaN(date.getTime()) ? null : date.toISOString();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      await axios.patch(
        `${process.env.REACT_APP_BASE_API_URL}/dfms-truck-defects/${id}/resolve`,
        {
          defect_status: form.resolved ? "RESOLVED" : "OPEN",
          resolved: form.resolved ? "Y" : "N",
          date_resolved: form.resolved ? convertToUTC(form.date_resolved) : null,
          resolution_remarks: form.resolution_remarks || null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage("DFMS defect resolved successfully.");
      setTimeout(() => navigate("/dfms-truck-defects"), 1200);
    } catch (error) {
      console.error("Error resolving DFMS defect:", error);
      setMessage(error.response?.data?.message || "Failed to resolve DFMS defect.");
    }
  };

  return (
    <div className="handle-violation-container">
      <button className="close-button" onClick={() => navigate("/dfms-truck-defects")}>x</button>
      <h2 className="handle-violation-header">Resolve DFMS Truck Defect</h2>
      {message && <div className={`violation-message ${message.includes("successfully") ? "success" : "error"}`}>{message}</div>}
      {recordInfo && (
        <div style={{ backgroundColor: "#f0f0f0", padding: "12px", borderRadius: "6px", marginBottom: "20px" }}>
          <strong>Truck:</strong> {recordInfo.truck} | <strong>Journey:</strong> {recordInfo.journey || "N/A"} | <strong>Driver:</strong> {recordInfo.driver || "N/A"}
        </div>
      )}

      <div className="handle-violation-form">
        <form onSubmit={handleSubmit}>
          <div className="handle-violation-item">
            <label>Resolution Remarks</label>
            <textarea name="resolution_remarks" value={form.resolution_remarks} onChange={handleChange} placeholder="Add repair or verification notes" />
          </div>
          <div className="handle-violation-item">
            <label>Date Resolved *</label>
            <input type="datetime-local" name="date_resolved" value={form.date_resolved} onChange={handleChange} required={form.resolved} />
          </div>
          <div className="checkbox-group">
            <input type="checkbox" name="resolved" id="resolved" checked={form.resolved} onChange={handleChange} />
            <label htmlFor="resolved">Mark as Resolved</label>
          </div>
          <div className="handle-violation-actions">
            <button type="submit" className="resolve">Save</button>
            <button type="button" className="cancel" onClick={() => navigate("/dfms-truck-defects")}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HandleDfmsTruckDefect;
